import React from 'react';
import BSOverlay from '../../../_utils/bs-overlay';
import Failures from '../../../_photo-loader/failures';
import { builderDispatch, WebUI } from '../../../_utils/ui';

class PrintsBuilderPhotoAlbumDirectLoader {
  constructor(uploadUrl, onBegunUploading, onUploaded, onDone) {
    this._uploadUrl = uploadUrl;
    this._onBegunUploading = onBegunUploading;
    this._onUploaded = onUploaded;
    this._onDone = onDone;

    this._pollInterval = 5000;
    this._doneHash = {};

    builderDispatch.register((payload) => {
      switch (payload.type) {
        case WebUI.UPLOAD_ABORTED:
        case WebUI.PHOTO_EVENT_REMOVE_PRINTS_CONFIRM:
          this._clearInterval();
          break;
      }
    });
  }

  slingshot(userPhotosIds) {
    const formData = new FormData();
    userPhotosIds.forEach((id) => formData.append('upload_from_gallery_photo_ids[]', id));
    formData.append('source', 'albums');

    fetch(this._uploadUrl, {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest', // in order for request.xhr? to be true
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (window.history) {
          window.history.replaceState({}, '', data.urls.prints_builder);
        }

        this.listen(data.urls.listener);
      });
  }

  listen(url) {
    perform.call(this, true);

    this._pollingIntervalID = setInterval(perform.bind(this), this._pollInterval);

    function perform(firstRun) {
      fetch(url, {
        credentials: 'same-origin',
      })
        .then((response) => response.json())
        .then((data) => this._processPollResponse(data, firstRun))
        .catch(() => { this._clearInterval() });
    }
  }

  _processPollResponse(response, firstRun = false) {
    if (firstRun) {
      this._onBegunUploading(response.total);
    }

    (response.images || []).forEach((image) => {
      if (this._doneHash.hasOwnProperty(image.image_id)) {
        return;
      }

      this._onUploaded(image, 'albums');
      this._doneHash[image.image_id] = image.image_id;
    });

    if (response.complete) {
      this._clearInterval();

      if (response.failures) {
        this._showErrorModal(response);
      } else {
        this._onDone(response.images.length, 0);
      }
    }
  }

  _clearInterval() {
    clearInterval(this._pollingIntervalID);
    this._pollingIntervalID = null;
  }

  _showErrorModal({ failures }) {
    const $modal = (
      <BSOverlay
        show
        onHide={handleIgnore}
      >
        <Failures
          numberOfFailures={failures.length}
          shouldRetry
          onIgnore={handleIgnore.bind(this)}
          onRetry={handleRetry.bind(this)}
        />
      </BSOverlay>
    );

    $('body').append('<div id="direct-album-loader-error" />');

    ReactDOM.render($modal, document.getElementById('direct-album-loader-error'));

    function handleIgnore() {
      builderDispatch.dispatch({
        type: WebUI.UPLOAD_ABORTED,
      });

      remove();
    }

    function handleRetry() {
      this.slingshot(failures.map((failure) => failure.id));

      remove();
    }

    function remove() {
      $('#direct-album-loader-error, .modal-backdrop').remove();
    }
  }
}

export default PrintsBuilderPhotoAlbumDirectLoader;
